import React from 'react'
import LoadingResults from './LoadingResults'

export default function LoadingText({ children }) {
  return (
    <span>
      {children} <LoadingResults />
    </span>
  )
}
